<template>
  <div style=" display: flex; flex-direction: column;">
    <el-image :src="url" style="margin: auto">
    </el-image>
  </div>
</template>

<script>
export default {
  name: "FileView",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data(){
    return{
      url:"",
      fileName:""
    }
  },
  methods:{
    async getFileUrl() {
      console.log(this.parentData)
      let object = await this.$http('crmService.getFile', this.parentData)
      this.url = object.url
    }
  },
  created() {
    if (this.parentData.quote_no){
      this.fileName = this.parentData.quote_no
    }
    if (this.parentData.contract_no){
      this.fileName = this.parentData.contract_no
    }
    if (this.parentData.calling_card){
      this.fileName = this.parentData.name
    }
    this.getFileUrl()
  }
}
</script>

<style scoped>

</style>